import React, { useCallback, useEffect, useMemo } from "react";
import flagsmith from "flagsmith";
import { FlagsmithProvider } from "flagsmith/react";
import { getEnvironment } from "@sunrun/sales-experience-shared";
import { useCustomerSalesRep } from "hooks/useCustomerSalesRep";
import { useAppSelector } from "store";
import { resolveFlagsmithIdentity } from "utils/resolveFlagsmithIdentity";

const FlagsmithEnvProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const env = getEnvironment();
  const identity = useAppSelector((state) => state.auth.identity);
  const proposalToken = useAppSelector((state) => state.auth.proposalToken);
  const isCustomer = Boolean(proposalToken);
  const { data: salesRep } = useCustomerSalesRep();

  const flagsmithIdentity = useMemo(
    () =>
      resolveFlagsmithIdentity({
        isCustomer,
        salesRepContactId: salesRep?.contactId,
        authIdentity: identity || undefined,
      }),
    [identity, isCustomer, salesRep?.contactId]
  );

  const setIdentity = useCallback((identityToSet: string) => {
    if (!flagsmith.initialised || flagsmith.loadingState?.isFetching) {
      window.setTimeout(() => {
        setIdentity(identityToSet);
      }, 100);
    } else {
      flagsmith.identify(identityToSet);
    }
  }, []);

  useEffect(() => {
    if (flagsmithIdentity) {
      setIdentity(flagsmithIdentity);
    }
  }, [flagsmithIdentity, setIdentity]);

  return (
    <FlagsmithProvider
      options={{
        environmentID:
          env === "production"
            ? "eyZgnuwbveRVcUsUC5PDre"
            : "QL5PWdxYnNQ4DdSJLusfqA",
      }}
      flagsmith={flagsmith}
    >
      <>{children}</>
    </FlagsmithProvider>
  );
};

export { FlagsmithEnvProvider };
